import { render, staticRenderFns } from "./assetPreviewInlineTranscription.vue?vue&type=template&id=087d152a&scoped=true&"
import script from "./assetPreviewInlineTranscription.vue?vue&type=script&lang=js&"
export * from "./assetPreviewInlineTranscription.vue?vue&type=script&lang=js&"
import style0 from "./assetPreviewInlineTranscription.vue?vue&type=style&index=0&id=087d152a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d152a",
  null
  
)

export default component.exports